import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';
import ForgotPassword from './ForgotPassword';

/**
 * First part of the forgotten password process
 * User provides their email address and is sent a confirmation link
 * @extends Component
 */
class ForgotPasswordContainer extends Component {
  handleSubmit = values => this.props.forgotPassword(values.get('email'));

  render() {
    const { ui } = this.props;
    return (
      <ForgotPassword
        onSubmit={this.handleSubmit}
        isLoading={ui.get('isLoading')}
        isError={ui.get('isError')}
        errorMessage={ui.get('errorMessage')}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  ui: selectors.getUI
});

export default connect(mapStateToProps, actions)(ForgotPasswordContainer);



// WEBPACK FOOTER //
// ./src/modules/auth/components/ForgotPasswordContainer.js